(() => {
  'use strict';

  const selectors = Object.freeze({
    RecoverHeading: '#RecoverHeading',
    RecoverEmail: '#RecoverEmail',
    LoginHeading: '#LoginHeading'
  });

  let recoverHeading;
  let recoverEmail;
  let loginHeading;

  const initEventListeners = () => {
    recoverHeading = document.querySelector(selectors.RecoverHeading);
    recoverEmail = document.querySelector(selectors.RecoverEmail);
    loginHeading = document.querySelector(selectors.LoginHeading);

    const recoverPasswordButton = document.querySelector('#RecoverPassword');
    recoverPasswordButton?.addEventListener('click', event => {
      event.preventDefault();
      showRecoverPasswordForm();
      recoverHeading?.setAttribute('tabindex', '-1');
      recoverHeading?.focus();
    });

    const hideRecoverPasswordLink = document.querySelector(
      '#HideRecoverPasswordLink'
    );
    hideRecoverPasswordLink?.addEventListener('click', event => {
      event.preventDefault();
      hideRecoverPasswordForm();
      loginHeading?.setAttribute('tabindex', '-1');
      loginHeading?.focus();
    });

    recoverHeading?.addEventListener('blur', () => {
      recoverHeading.removeAttribute('tabindex');
    });

    loginHeading?.addEventListener('blur', () => {
      loginHeading.removeAttribute('tabindex');
    });
  };

  /**
   *
   *  Show/Hide recover password form
   *
   */

  function showRecoverPasswordForm() {
    const recoverPasswordForm = document.querySelector('#RecoverPasswordForm');
    const customerLoginForm = document.querySelector('#CustomerLoginForm');

    recoverPasswordForm?.classList.remove('hide');
    customerLoginForm?.classList.add('hide');

    if (recoverEmail?.getAttribute('aria-invalid') === 'true') {
      recoverEmail.focus();
    }
  }

  function hideRecoverPasswordForm() {
    const recoverPasswordForm = document.querySelector('#RecoverPasswordForm');
    const customerLoginForm = document.querySelector('#CustomerLoginForm');

    recoverPasswordForm?.classList.add('hide');
    customerLoginForm?.classList.remove('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    const formState = document.querySelector('.reset-password-success');

    if (!formState) {
      return;
    }

    const resetSuccess = document.querySelector('#ResetSuccess');

    if (resetSuccess) {
      resetSuccess.classList.remove('hide');
      resetSuccess.focus();
    }
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    const newAddressForm = document.querySelector('#AddressNewForm');
    const newAddressFormButton = document.querySelector('#AddressNewButton');

    if (!newAddressForm) {
      return;
    }

    if (typeof Shopify !== 'undefined' && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    const addressCountryOptions = document.querySelectorAll(
      '.address-country-option'
    );

    addressCountryOptions.forEach(option => {
      const formId = option.dataset.formId;
      if (!formId) {
        return;
      }

      const countrySelector = `AddressCountry_${formId}`;
      const provinceSelector = `AddressProvince_${formId}`;
      const containerSelector = `AddressProvinceContainer_${formId}`;

      if (typeof Shopify !== 'undefined' && Shopify.CountryProvinceSelector) {
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(
          countrySelector,
          provinceSelector,
          {
            hideElement: containerSelector
          }
        );
      }
    });

    const addressNewToggles = document.querySelectorAll('.address-new-toggle');
    addressNewToggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const isExpanded =
          newAddressFormButton?.getAttribute('aria-expanded') === 'true';

        newAddressForm.classList.toggle('hide');
        newAddressFormButton?.setAttribute(
          'aria-expanded',
          (!isExpanded).toString()
        );
        newAddressFormButton?.focus();
      });
    });

    const addressEditToggles = document.querySelectorAll('.address-edit-toggle');
    addressEditToggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const formId = toggle.dataset.formId;
        if (!formId) {
          return;
        }

        const editButton = document.querySelector(`#EditFormButton_${formId}`);
        const editAddress = document.querySelector(`#EditAddress_${formId}`);

        if (!editButton || !editAddress) {
          return;
        }

        const isExpanded = editButton.getAttribute('aria-expanded') === 'true';

        editAddress.classList.toggle('hide');
        editButton.setAttribute('aria-expanded', (!isExpanded).toString());
        editButton.focus();
      });
    });

    const addressDeleteButtons = document.querySelectorAll('.address-delete');
    addressDeleteButtons.forEach(button => {
      button.addEventListener('click', () => {
        const target = button.dataset.target;
        const confirmMessage = button.dataset.confirmMessage;

        // eslint-disable-next-line no-alert
        if (
          confirm(
            confirmMessage || 'Are you sure you wish to delete this address?'
          )
        ) {
          if (typeof Shopify !== 'undefined' && Shopify.postLink && target) {
            Shopify.postLink(target, {
              parameters: { _method: 'delete' }
            });
          }
        }
      });
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    const hash = window.location.hash;

    if (hash === '#recover') {
      showRecoverPasswordForm();
    }
  }

  window.addEventListener('DOMContentLoaded', () => {
    initEventListeners();
    checkUrlHash();
    resetPasswordSuccess();
    customerAddressForm();
  });
})();